<template>
  <div class="base-container">
    <h3 v-if="$vuetify.breakpoint.smAndDown" class="secondary-font text--secondary text-center py-8">
      Ficha Clínica
    </h3>
    <v-row no-gutters justify="center" align="center" :class="$vuetify.breakpoint.smAndDown ? 'mt-15' : 'h-100'">
      <v-col cols="10" sm="7" md="6" lg="5" class="text-center">
        <h2 class="secondary-font">Bem vindo {{ nome }}!</h2>
        <h3 class="secondary-font text--secondary mt-5">
          Esta é a sua ficha clínica, precisamos de alguns dados para liberar sua guia de atendimento. O preenchimento
          deste formulário irá reduzir o tempo gasto na clínica.
        </h3>
        <v-row no-gutters justify="center" align="center" class="mt-10">
          <v-col cols="7" sm="4" md="4" lg="4">
            <v-btn
              @click="onClick"
              color="primary"
              class="secondary-font text-capitalize py-7 font-weight-bold"
              elevation="24"
              rounded
              x-large
              block
              >Continuar
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right-bold-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align="center" class="mt-7">
          <v-col cols="7" sm="4" md="4" lg="4">
            <v-btn
              :to="onCancelRoute"
              color="error"
              class="secondary-font text-capitalize font-weight-black"
              outlined
              rounded
              >Cancelar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import fichaClinicaService from '@/services/fichaClinica'

export default {
  props: {
    onCancelRoute: {
      default: '/agendamentos'
    }
  },
  computed: {
    ...mapState('authentication', ['nome'])
  },
  methods: {
    async onClick() {
      this.$showLoading()
      try {
        const { data } = await fichaClinicaService.verificaDados()
        const { preencheuDados } = data

        if (preencheuDados) {
          this.$router.push('perguntas')
        } else {
          this.$router.push('dados')
        }
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  }
}
</script>
